import { getRequestId, updateRequest } from '../dataLayer';
import { info } from '../Env';
import { parseUriQuery } from '../web';
import { doWhenP } from '../utils';
import { getCacheItem, setCacheItem } from '../cache';
export function run(expiration = 10000) {
    return doWhenP(() => getRequestId(), expiration, false)
        .then(requestId => {
        var _a, _b;
        const query = parseUriQuery();
        const sent = getCacheItem('sentSmsIds') || {};
        const smsId = (_a = query === null || query === void 0 ? void 0 : query.sms_id) !== null && _a !== void 0 ? _a : '';
        const smsOptinId = (_b = query === null || query === void 0 ? void 0 : query.sms_optin_id) !== null && _b !== void 0 ? _b : '';
        if (!smsOptinId || sent[`${smsId}:${smsOptinId}`]) {
            return {};
        }
        return updateRequest(requestId, {
            sms_opt_in: {
                request_id: requestId,
                sms_id: smsId,
                sms_optin_id: smsOptinId,
            },
        }).then(() => {
            const sentIds = getCacheItem('sentSmsIds') || {};
            sentIds[`${smsId}:${smsOptinId}`] = true;
            setCacheItem('sentSmsIds', sentIds);
        });
    })
        .catch(e => {
        info(`error sending SmsOptIn: ${e}`);
        return e;
    });
}
//# sourceMappingURL=SmsOptIn.js.map